// Module
var code = "<div class=\"widget-content relative doughnut-chart-widget\"> <wt-loading-panel is-loading=\"vm.isLoading\"></wt-loading-panel> <wt-doughnut-chart class=\"fill\" component-id=\"openTicketDoughnut\" data=\"vm.data\" options=\"vm.options\" series=\"vm.series\"> </wt-doughnut-chart> </div>";
// Exports
module.exports = code;